import React, { Fragment } from 'react';

const Arr = (arr) => React.createElement(Fragment, null, ...arr);

export default Arr;
